var module = angular.module('asebiol', [
        'ui.router',
        'ui.bootstrap',
        'restangular',
        'angularSpinner',
        'oitozero.ngSweetAlert',
        'permission',
        'textAngular',
        'angularMoment',
        'internationalPhoneNumber',
        'angularFileUpload',
        'ui.calendar',
        'ui.tinymce',
        'chart.js',
        'RecursionHelper',
        'angularUtils.directives.dirPagination',
        'ui.select',
        'ngSanitize',
        'datePicker',
        'ui.tree',
        'focus-if',
        'ngDragDrop',
        'daterangepicker',
        'ngQtip2',
        'duScroll',
        'signature',
        'angularScreenfull',
        'xeditable',
        'ngFileUpload',
        'ngPrettyJson',
        'dndLists',
        'wt.responsive',
        'ngAnimate',
        'ngToast',
        'nvd3',
        'LocalStorageModule'
    ]);

var frontEndProperties = {
    host: null,
    port: null,
    baseUrl: null,
    logoutRedirect: null
};

var auth = {};

var logout = function(){
    auth.loggedIn = false;
    auth.authz = null;
    window.location = auth.logoutUrl;
};

angular.element(document).ready(function ($http) {

    /* Load default frontEnd properties */
    var frontEnd = new FrontEndProperties('frontend-properties.json');
    frontEnd.init().success(function () {
        frontEndProperties.host = frontEnd.host;
        frontEndProperties.port = frontEnd.port;
        frontEndProperties.baseUrl = frontEnd.baseUrl;
        frontEndProperties.logoutRedirect = frontEnd.logoutRedirect;

        /* If frontEnd properties where loaded then init KeyCloak */
        loadKeycloakConfiguration();
    }).error(function () {
        alert("failed load frontEnd configuration");
    });

    /* KeyCloak Initialization */
    function loadKeycloakConfiguration(){
        var keycloakAuth = new Keycloak('keycloak.json');
        auth.loggedIn = false;

        keycloakAuth.init({ onLoad: 'login-required' }).success(function () {
        	
            auth.loggedIn = true;
            auth.authz = keycloakAuth;
            auth.logoutUrl = keycloakAuth.authServerUrl + "/realms/" + keycloakAuth.realm + "/protocol/openid-connect/logout?redirect_uri=" + frontEndProperties.logoutRedirect;
            
            module.factory('Auth', function() {
                return auth;
            });
            
            module.factory('Identity', function () {
                return new Identity(keycloakAuth);
            });
            
            angular.bootstrap(document, ["asebiol"]);
            
        }).error(function () {
            alert("keycloak failed to login");
        });
    };

});

